import { Component, OnInit, Input } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { past_medical_history_data } from '../../../../models/history';
import { consultation_table_model, PatientProfile, PatientProfileQuery, patient_consultation } from '../../../../models/patient-profile';
import { Prescription } from '../../../../models/prescription';
import { PromiseResult, ServerError } from '../../../../models/PromiseResult';
import { PatientProfileService } from '../../../../services/patient-profile.service';
import { BreadcrumbService } from '../../../patient/shared/breadcrumb.service';
import { Router } from '@angular/router';
import { DoctorsService } from '../../../../services/doctors.service';
import { reportspdf } from 'src/app/models/reportspdf';
import { TraceClassDecorator } from '@sentry/angular';
import { MedicalReports } from 'src/app/components/shared/patient-view/medical-reports/medical-reports.component';
import { DateUtilService , moment_duration } from 'src/app/utilities/date.util.service';
import { ProviderStateService } from 'src/app/services/provider-state.service';
interface file_Obj {
    file_id: number;
    document_link: string;
    document_key?: string;
    document_name: string;
    document_size: number;
    updated_at?: Date;
}
interface DocumentData {
    id: number;
    name: string;
    data: file_Obj[]
}
@TraceClassDecorator()
@Component({
    selector: 'app-patient-profile',
    templateUrl: './patient-profile.component.html',
    styleUrls: ['./patient-profile.component.css'
        , '../../../../../assets/css/custom-egd.css'
        , '../../../../../assets/css/print-prescription.css'
    ]
})
export class PatientProfileComponent implements OnInit {
    // @ViewChild(PrescriptionComponent ) prescriptionComp: PrescriptionComponent ;

    @Input('patient_guid')
    patient_guid: string = null;
    @Input('consultation_id')
    consultation_id: number = null;
    @Input('token')
    token: string = null;
    @Input('user_guid')
    user_guid: string = null;

    textarea_data: any = [];
    doctor_reports;
    textarea;
    social_history;
    smoking;
    alcohol;
    display1: boolean = false;
    smoking_type = null;
    no_of_packs = "";
    no_of_years_smoked = "";
    year_of_quitting_smoke = null;
    alcohol_type = null;
    drinks_per_week = "";
    year_of_quitting_alcohol = null;
    medical_history_count: number = 0;
    display: boolean = false;
    view_health_data: PatientProfile = null;
    consultations: consultation_table_model[] = [];
    TZ: any = Intl.DateTimeFormat().resolvedOptions().timeZone;
    displayedColumns: string[] = [
        "RNo",
        "date",
        "opiniontype",
        "speciality",
        "doctorreport",
    ];
    displayedColumns1: string[] = ["condition", "yod", "status"];
    dateTime = new Date();
    refresh = false;
    medical_history: past_medical_history_data[] = [];
    allergy_list: any = [];
    medication_list = [];
    upload_records_data;
    medication_data;
    allergy_data;
    family_history_data;
    social_history_data;
    past_medical_history_data;
    c_data = [];
    condition_description = "";
    past_medical_surgical_history = ""
    query: PatientProfileQuery;
    response: PromiseResult;
    serverError: ServerError;
    posting: boolean;
    id;
    showPrescriptiond: string = "showPrescription";
    showDoctorReportsd: string = "showDoctorReports";
    printContent: string = "print-content";
    prescriptionData: reportspdf
    prescriptionSuccessd: boolean = null;
    doctorReportsData: reportspdf
    doctorReportsSuccessd: boolean = null;
    displayModel: boolean = false;
    displayModel1: boolean = false;
    doctor_user_id: string;
    success = false;
    slug: string = "";
    MedicalReports: MedicalReports = new MedicalReports();
    constructor(
        private readonly router: Router,
        private readonly breadcrumbService: BreadcrumbService,
        private readonly titleService: Title,
        private readonly patientprofileService: PatientProfileService,
        private readonly DoctorsService: DoctorsService,
        private readonly dateUtil: DateUtilService,
        private readonly providerstateService: ProviderStateService

    ) {
       
        this.posting = false;
    }
    patient_age: string;
    prescriptions: Prescription[] = [];

    Document_data: DocumentData[] = [];

    members = [
        { name: "Mother", data: [] },
        { name: "Father", data: [] },
        { name: "Brother", data: [] },
        { name: "Sister", data: [] },
    ];

    imageContainerID: string = "1";

    async ngOnInit() {
        this.slug = this.providerstateService.getProviderSlug();
        this.breadcrumbService.setItems([
            { label: "Dashboard", routerLink:['/', this.slug, 'patient']
            },
            { label: "View Health Summary" },
        ]);
        this.response = {
            success: null,
            error: null,
            data: null
        }
        this.serverError = {
            statusCode: null,
            error: null,
            message: null
        }
        this.patient_age = '0';
        if (this.patient_guid == null) {
            this.response = {
                success: false,
                error: {
                    code: "REQ_INV",
                    message: "ID is invalid"
                },
                data: null
            }
        }
        this.doctor_user_id = sessionStorage.getItem('userid');
        if (this.token == null) {
            this.user_guid = null
        }
        else if (this.token != null) {
            this.user_guid = this.doctor_user_id;
        }
        this.query = {
            patient_guid: this.patient_guid,
            consultation_id: this.consultation_id,
            token: this.token,
            user_guid: this.user_guid
        }

        this.dateTime.setDate(this.dateTime.getDate());
        this.c_data = [];
        this.doctor_reports = [];
        this.upload_records_data = " ";
        this.medication_data = " ";
        this.allergy_data = " ";
        this.family_history_data = " ";
        this.social_history_data = " ";
        this.past_medical_history_data = " ";
        this.condition_description = "";
        this.past_medical_surgical_history = "";;
        this.view_health_data = null;
        this.show_prescription_id = -1;

        await this.GetProfile();
    }

    private async GetProfile() {
        this.response = {
            success: null,
            error: null,
            data: null
        }
        this.serverError = {
            statusCode: null,
            error: null,
            message: null
        }
        this.posting = true;
        this.MedicalReports.data.api_result.Posting = true;
        await this.patientprofileService.GetProfile(this.query).toPromise().then(async result => {
            this.response = result;
            if (result.success) {
                this.success = true;
                this.view_health_data = result.data;
                await this.GetTextareaData();
                await this.process_consultations(this.view_health_data.consultation.consultations);
                this.MedicalReports.data.api_result.PromiseResult = {
                    success: result.success,
                    data: this.view_health_data.documents,
                    error: result.error
                }
            }
            else {
                this.MedicalReports.data.api_result.PromiseResult = {
                    success: result.success,
                    data: {},
                    error: result.error
                }
            }
            this.posting = false;
            this.MedicalReports.data.api_result.Posting = false;
        })
    }
    show_prescription_id: number;
    private async process_consultations(consultation: patient_consultation[]): Promise<void> {
        const temp: consultation_table_model[] = [];
        for (let i = 0; i < consultation.length; i++) {
            temp.push(
                {
                    sr_no: i,
                    consultation_date: consultation[i].consultation_date,
                    specialty_name: consultation[i].p_consultation_appointment.map(appt => {
                        return appt.d_specialty_type.specialty_name
                    }),
                    priority_type: consultation[i].priority_type.priority_type,
                    doctor_name: consultation[i].p_consultation_appointment.map(appt => {
                        return !consultation[i].consultation_date ? 'N/A' : appt.egd_users.first_name + ' ' + appt.egd_users.last_name
                    }),
                    doctor_report: "",
                    prescriptions: consultation[i].p_prescriptions,
                    consultation_id: consultation[i].id,
                    consultation_status: consultation[i].consultation_status,
                }
            )
        }
        this.consultations = temp;

    }

    async show_prescription(id: number, show: boolean): Promise<void> {
        this.prescriptions = this.consultations[id].prescriptions;
        if (!show) {
            this.show_prescription_id = -1;
            this.prescriptions = [];
        }
        else this.show_prescription_id = id;

    }

    showviewall() {
        this.display = true;
    }
    async yearsDiff(d1: Date, d2: Date): Promise<number> {
        const date1 = new Date(d1);
        const date2 = new Date(d2);
        return date2.getFullYear() - date1.getFullYear();
    }

    downloadPdf(pdfUrl: string, pdfName: string) {
        // FileSaver.saveAs(pdfUrl, pdfName);
    }
    private async preprocess_familyhistory(raw_familyhistory: any[]) {
        for (const member of this.members) {
            for (const raw_member of raw_familyhistory) {
                if (member.name == raw_member.name) {
                    const temp = [];
                    for (const hist of raw_member.data) temp.push(
                        {
                            "name": hist
                        }
                    )
                    member.data = temp;
                }
            }
        }

    }

    private async GetTextareaData() {
        this.patient_age = await this.dateUtil.diff(this.view_health_data.patient.date_of_birth, new Date(), moment_duration.years) + ' Yrs';
        this.c_data = [];
        this.upload_records_data = "";
        this.medication_data = "";
        this.allergy_data = "";
        this.family_history_data = "";
        this.social_history_data = "";
        this.past_medical_history_data = "";
        let is_selected_true = [];
        this.condition_description = "";

        if (this.view_health_data.condtion != null) {
            if (this.view_health_data.condtion.current_medical_problems.length > 0) {
                let data = this.view_health_data.condtion.current_medical_problems;
                this.condition_description = data;
            }
        }

        if (this.view_health_data.condtion == null) {
            this.condition_description = "N/A";
        }

        if (this.view_health_data.history != null) {

            if (this.view_health_data.history.family_history.length > 0) {
                this.preprocess_familyhistory(this.view_health_data.history.family_history)
            }

            if (this.view_health_data.history.past_medical_history_data.length > 0) {

                this.medical_history = this.view_health_data.history.past_medical_history_data;
            }

            this.past_medical_history_data = "", is_selected_true = [];
            if (this.medical_history.length == 0) {
                this.past_medical_history_data = "N/A";
            }
            for (let j = 0; j < this.medical_history.length; j++) {
                if (j == 0 && j == this.medical_history.length - 1) {
                    this.past_medical_history_data += this.medical_history[j].name + ". \n";
                }
                else if (j == 0) {
                    this.past_medical_history_data += this.medical_history[j].name;
                }
                else if (j == this.medical_history.length - 1) {
                    this.past_medical_history_data += ", " + this.medical_history[j].name + ". \n";
                }
                else
                    this.past_medical_history_data += ", " + this.medical_history[j].name;

            }

            this.family_history_data = "";
            for (let i = 0; i < this.members.length; i++) {

                if (this.members[i].data.length > 0) {

                    this.family_history_data += this.members[i].name;
                    for (let j = 0; j < this.members[i].data.length; j++) {

                        if (j == 0 && j == this.members[i].data.length - 1) {
                            this.family_history_data += " : " + this.members[i].data[j].name + ". \n";
                        }
                        else if (j == 0) {
                            this.family_history_data += " : " + this.members[i].data[j].name;
                        }
                        else if (j == this.members[i].data.length - 1) {
                            this.family_history_data += ", " + this.members[i].data[j].name + ". \n";
                        }
                        else
                            this.family_history_data += ", " + this.members[i].data[j].name;

                    }

                }
            }
            if (this.family_history_data.length == 0) this.family_history_data = "N/A";

            if (this.view_health_data.history.past_surgical_history_data.length > 0) {
                this.past_medical_surgical_history = this.view_health_data.history.past_surgical_history_data;
            }
            this.social_history_data = "";

            if (this.view_health_data.history.social_history != null) {
                this.alcohol = this.view_health_data.history.social_history.alcohol;
                this.smoking = this.view_health_data.history.social_history.smoking;
                this.smoking_type = this.smoking.selected;
                this.alcohol_type = this.alcohol.selected;
                if (this.smoking_type == "Yes") {
                    this.no_of_packs = this.smoking.data.number_of_packs_per_day;
                    this.no_of_years_smoked = this.smoking.data.numbers_of_years_smoked;
                    this.year_of_quitting_smoke = null;
                    this.social_history_data += "Smoking :" + this.smoking_type + "\n" + " Number of Packs :" + this.no_of_packs + "\n Number of Years :" + this.no_of_years_smoked + "\n";
                }
                else if (this.smoking_type == "Not Currently") {
                    this.no_of_packs = "";
                    this.no_of_years_smoked = "";
                    this.year_of_quitting_smoke = { name: this.smoking.data.year_of_quitting };
                    this.social_history_data += "Smoking :" + this.smoking_type + "\n" + " Year of Quitting :" + this.year_of_quitting_smoke.name + "\n";

                }
                else if (this.smoking_type == "Never") {
                    this.no_of_packs = "";
                    this.no_of_years_smoked = "";
                    this.year_of_quitting_smoke = null;
                    this.social_history_data += "Smoking :" + this.smoking_type + "\n";

                }
                this.social_history_data += "\n";
                if (this.alcohol_type == "Yes") {
                    this.drinks_per_week = this.alcohol.data.drinks_per_week;
                    this.year_of_quitting_alcohol = null;
                    this.social_history_data += "Alcohol :" + this.alcohol_type + " \n Drinks per week :" + this.drinks_per_week + "\n";

                }
                else if (this.alcohol_type == "Not Currently") {
                    this.drinks_per_week = "";
                    this.year_of_quitting_alcohol = { name: this.alcohol.data.year_of_quitting };
                    this.social_history_data += "Alcohol :" + this.alcohol_type + "\n Year of Quitting :" + this.year_of_quitting_alcohol.name + "\n";
                }
                else if (this.alcohol_type == "Never") {
                    this.drinks_per_week = "";
                    this.year_of_quitting_alcohol = null;
                    this.social_history_data += "Alcohol :" + this.alcohol_type + "\n";
                }
            }


            if (this.view_health_data.history.social_history == null) {
                this.social_history_data = "N/A";
            }
            if (this.view_health_data.history.past_medical_history_data == null) {
                this.past_medical_history_data = "N/A";
            }
            if (this.view_health_data.history.family_history == null) {
                this.family_history_data = "N/A";
            }
            if (this.view_health_data.history.past_surgical_history_data == null) {
                this.past_medical_surgical_history = "N/A";
            }


            if (this.view_health_data.history.past_medical_history_data.length == 0) {
                this.past_medical_history_data = "N/A";
            }
            if (this.view_health_data.history.family_history.length == 0) {
                this.family_history_data = "N/A";
            }
            if (this.view_health_data.history.past_surgical_history_data.length == 0) {
                this.past_medical_surgical_history = "N/A";
            }
        }

        if (this.view_health_data.allergies_medications != null) {


            this.medication_list = this.view_health_data.allergies_medications.medications_allergies_data.medications;
            this.medication_data = "";

            if (this.medication_list.length > 0) {
                this.medication_data += ""
                for (let j = 0; j < this.medication_list.length; j++) {


                    let times_per_day = this.medication_list[j].times_per_day.trim().length > 0 ? this.medication_list[j].times_per_day : "N/A";
                    if (!Boolean(this.medication_list[j]['instructions'])) {
                        this.medication_list[j]['instructions'] = "";
                    }
                    let instructions = this.medication_list[j].instructions.trim().length > 0 ? this.medication_list[j].instructions : "N/A";
                    this.medication_data += "Medication Name : " + this.medication_list[j].name + "    Dose : " + this.medication_list[j].dose + "    Times Per Day : " + times_per_day + "    Instructions : " + instructions + " . \n";
                }
            }

            if (this.view_health_data.allergies_medications.medications_allergies_data.allergies.length == 0 && this.view_health_data.allergies_medications.medications_allergies_data.medications.length == 0) {
                this.medication_data = "N/A";
            }
        }

        if (this.view_health_data.allergies_medications != null) {

            this.allergy_list = this.view_health_data.allergies_medications.medications_allergies_data.allergies;
            this.allergy_data = "";
            if (this.allergy_list.length > 0) {
                this.allergy_data += "";
                for (let j = 0; j < this.allergy_list.length; j++) {
                    this.allergy_data += "Allergy Name : " + this.allergy_list[j].name + "    Allergic Reaction : " + this.allergy_list[j].reaction + " . \n";
                }
            }
            if (this.view_health_data.allergies_medications.medications_allergies_data.allergies == null && this.view_health_data.allergies_medications.medications_allergies_data.medications == null) {
                this.allergy_data = "N/A";
            }
        }

        if (this.upload_records_data.length == 0) {
            this.upload_records_data = "N/A";
        }
        if (this.condition_description.length == 0) {
            this.condition_description = "N/A";
        }
        if (this.past_medical_history_data.length == 0) {
            this.past_medical_history_data = "N/A";
        }
        if (this.past_medical_surgical_history.length == 0) {
            this.past_medical_surgical_history = "N/A";
        }
        if (this.family_history_data.length == 0) {
            this.family_history_data = "N/A";
        }
        if (this.social_history_data.length == 0) {
            this.social_history_data = "N/A";
        }
        if (this.medication_data.length == 0) {
            this.medication_data = "N/A";
        }
        if (this.allergy_data.length == 0) {
            this.allergy_data = "N/A";
        }
        this.c_data.push(
            {
                condition_description: this.condition_description,
                past_medical_history: this.past_medical_history_data,
                past_surgical_history: this.past_medical_surgical_history,
                family_history: this.family_history_data,
                social_history: this.social_history_data,
                medication: this.medication_data,
                allergy: this.allergy_data,
                ur: this.upload_records_data
            }
        );
        this.textarea = this.c_data;
    }

    SetTitle(title: string) {
        this.titleService.setTitle(title);
    }

    private async GetPrescriptionData() {
        await this.DoctorsService.GetDoctorReportspdf(this.patient_guid, this.consultation_id, "prescription")
            .toPromise().then(result => {
                this.prescriptionSuccessd = result.success
                if (result.success) {
                    this.response = result;
                    this.prescriptionData = result.data;
                }
            })
    }

    private async GetDoctorReportsData() {
        await this.DoctorsService.GetDoctorReportspdf(this.patient_guid, this.consultation_id, "report")
            .toPromise()
            .then(result => {
                this.doctorReportsSuccessd = result.success
                if (result.success) {
                    this.response = result;
                    this.doctorReportsData = result.data;
                }
            });
    }

    print() {
        window.print();
    }
    async CloseDialog(): Promise<void> {
        this.displayModel = false;
        this.displayModel1 = false;

    }
    async gotoReportpdf(consultation_id: number) {
        this.patient_guid = this.patient_guid;
        this.consultation_id = consultation_id;
        await this.GetDoctorReportsData()
        this.displayModel1 = true;
    }

    async gotoprescription(consultation_id: number) {
        this.patient_guid = this.patient_guid;
        this.consultation_id = consultation_id;
        await this.GetPrescriptionData();
        this.displayModel = true;
    }

    RouterNavigation(path: string) {
        this.router.navigate([path]);
    }
}
